import * as React from 'react'
import { useMatch } from 'react-router-dom'

import { Box, Link, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { usePayrollPaywallingGuard } from 'modules/payroll_bundle/hooks/usePayrollPaywallGuard'

import BannerProfessionalsLogo from './banner-professionals-logo.svg'

const ProfessionalsBanner = () => {
  const { navigation } = useNavigation()
  const isDashboardActive = !!useMatch({ path: navigation.dashboard.fullPath(), end: false })
  const { isPayrollAvailable } = usePayrollPaywallingGuard()

  return (
    <>
      {isDashboardActive && isPayrollAvailable && (
        <Box
          flexDirection="row"
          paddingX="s16"
          paddingY="s12"
          width="full"
          justifyContent="spaceBetween"
          alignItems="center"
          background="grey000White"
          style={{ boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.05)' }}
        >
          <Box paddingLeft="s12">
            <Text.Normal weight="medium">
              {i18n.t('bookkeepers.professionals_access_banner_description')}
            </Text.Normal>
          </Box>
          <Box paddingRight="s12">
            <Link.Href href={navigation.bookkeepers.fullPath()} target={'_blank'}>
              <Box>
                <img src={BannerProfessionalsLogo} />
              </Box>
            </Link.Href>
          </Box>
        </Box>
      )}
    </>
  )
}

export default observer(ProfessionalsBanner)
